<template>
  <div>
    <div :id="chartId" style="width:100%;height:100%"></div>
  </div>
</template>

<script>
import * as echarts from "echarts"
var leiDom
var leiChart
var leioption
export default {
  props: {
    juData: {
      type: Object,
      require: true,
    },
    chartId: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      colorList: {
        linearYtoG: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "#f5b44d",
            },
            {
              offset: 1,
              color: "#28f8de",
            },
          ],
        },
        linearGtoB: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: "#43dfa2",
            },
            {
              offset: 1,
              color: "#28f8de",
            },
          ],
        },
        linearBtoG: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            {
              offset: 0,
              color: "#1c98e8",
            },
            {
              offset: 1,
              color: "#28f8de",
            },
          ],
        },
        areaBtoG: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(35,184,210,.2)",
            },
            {
              offset: 1,
              color: "rgba(35,184,210,0)",
            },
          ],
        },
      },
    }
  },
  // watch:{
  //   chartId(chartId){
  //     console.log(chartId);
  //     // this.leidaChatCanvas(id)
  //   }
  // },
  mounted() {
    this.$nextTick(() => {
      this.feedChatCanvas()
    })
    //  console.log(this.chartId);
  },
  methods: {
    feedChatCanvas() {
      // console.log(id);
      leiDom = document.getElementById(this.chartId)
      // if (leiChart != null && leiChart != "" && leiChart != undefined) {
      //   leiChart.dispose(); //销毁
      // }
      leiChart = echarts.init(leiDom)
      leioption = {
        title: {
          text: "",
        },
        legend: {
          data: [this.juData.name],
          bottom: "1%",
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
          itemStyle: {
            color: this.juData.color,
          },
        },
        tooltip: {
          trigger: "item",
        },
        radar: {
          center: ["50%", "50%"],
          radius: "55%",
          name: {
            color: "#fff",
          },
          splitNumber: 8,
          axisLine: {
            lineStyle: {
              color: this.colorList.linearYtoG,
              opacity: 0.6,
            },
          },
          splitLine: {
            lineStyle: {
              color: this.colorList.linearYtoG,
              opacity: 0.6,
            },
          },
          splitArea: {
            areaStyle: {
              color: "#fff",
              opacity: 0.1,
              shadowBlur: 25,
              shadowColor: "#000",
              shadowOffsetX: 0,
              shadowOffsetY: 5,
            },
          },
          indicator: [
            {
              name: "涉及城市",
              max: 100,
            },
            {
              name: "续签率",
              max: 100,
            },
            {
              name: "就业人员",
              max: 100,
            },
            {
              name: "岗位数",
              max: 100,
            },
          ],
        },
        grid: {
          left: "10%",
          right: "10%",
          bottom: "10%",
          top: "10%",
        },
        series: [
          {
            name: this.juData.name,
            type: "radar",
            symbolSize: 0,
            data: [
              {
                value: this.juData.data,
                name: this.juData.name,
                itemStyle: {
                  normal: {
                    color: this.juData.color,
                  },
                },
                lineStyle: {
                  normal: {
                    opacity: 0,
                  },
                },
                areaStyle: {
                  normal: {
                    color: this.juData.color,
                    shadowBlur: 15,
                    shadowColor: "rgba(0,0,0,.2)",
                    shadowOffsetX: 0,
                    shadowOffsetY: 5,
                    opacity: 0.8,
                  },
                },
              },
            ],
          },
        ],
      }
      leiChart.setOption(leioption)
      window.addEventListener("resize", function() {
        leiChart.resize() //下面可以接多个图
      })
    },
  },
}
</script>

<style></style>
